import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {

  constructor(private route: ActivatedRoute,
    private router: Router) {

  }

  signOut() {
    localStorage.removeItem('currentUser');
    this.router.navigate(['/login'])
  }

}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts